// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BoostController from "./boost_controller"
application.register("boost", BoostController)

import IntakeController from "./intake_controller"
application.register("intake", IntakeController)

import CreditController from "./credit_controller"
application.register("credit", CreditController)

import PaymentController from "./payment_controller"
application.register("payment", PaymentController)

import DeliveryController from "./delivery_controller"
application.register("delivery", DeliveryController)

import OrderController from "./order_controller"
application.register("order", OrderController)

import RequestController from "./request_controller"
application.register("request", RequestController)

import CardController from "./card_controller"
application.register("card", CardController)

import TaxPrepProviderNewController from "./tax_prep_provider_new_controller"
application.register("tax-prep-provider-new", TaxPrepProviderNewController)

import TaxPrepProfileController from "./tax_prep_profile_controller"
application.register("tax-prep-profile", TaxPrepProfileController)

import TaxPrepProviderInfoController from "./tax_prep_provider_info_controller"
application.register("tax-prep-provider-info", TaxPrepProviderInfoController)

import TaxPrepAdditionalInformationController from "./tax_prep_additional_information_controller"
application.register("tax-prep-additional-information", TaxPrepAdditionalInformationController)
